module.exports = __webpack_public_path__ + "img/renmin.f9f9e996.png";